import React from "react";

export default function ExampleListing() {
    return (
    <main>
        <div className="row table-toolbar mb-3">
            <div className="col-6 align-self-center">
                <div className="h6 d-inline"><span className="text-warning">&#8226;</span> Users Management</div>
                <span className="ms-1">/</span> <span className="text-muted">Add New</span>
            </div>
            <div className="col-6 text-end align-self-center toolbars">
            </div>
        </div>
        <div className="rounded bg-white p-4 shadow">
            <h6 className="bg-light p-2">Add New User</h6>
            <form className="row g-3">
                <div className="col-md-6">
                    <label htmlFor="inputEmail4" className="form-label">ชื่อจริง</label>
                    <input type="text" className="form-control border-danger" id="inputEmail4" />
                </div>
                <div className="col-md-6">
                    <label htmlFor="inputPassword4" className="form-label">นามสกุล</label>
                    <input type="text" className="form-control" id="inputPassword4" />
                </div>
                <div className="col-12">
                    <label htmlFor="inputAddress" className="form-label">ที่อยู่</label>
                    <textarea type="text" className="form-control" id="inputAddress" rows="2"></textarea>
                </div>
                <div className="col-md-6">
                    <label htmlFor="inputCity" className="form-label">จังหวัด</label>
                    <select id="inputState" className="form-select">
                        <option selected>Choose...</option>
                        <option>...</option>
                    </select>
                </div>
                <div className="col-md-6">
                        <label htmlFor="inputCity" className="form-label">อำเภอ</label>
                    <select id="inputState" className="form-select">
                        <option selected>Choose...</option>
                        <option>...</option>
                    </select>
                </div>
                <div className="col-md-6">
                    <label htmlFor="inputCity" className="form-label">ตำบล</label>
                    <select id="inputState" className="form-select">
                        <option selected>Choose...</option>
                        <option>...</option>
                    </select>
                </div>
                <div className="col-md-6">
                    <label htmlFor="inputZip" className="form-label">รหัสไปรษณีย์</label>
                    <input type="text" className="form-control" id="inputZip" />
                </div>
                <div className="col-md-6">
                    <div className="form-check form-switch form-select-lg">
                        <input className="form-check-input float-none" type="checkbox" id="flexSwitchCheckChecked" checked />
                        <label className="form-check-label ps-2" htmlFor="flexSwitchCheckChecked">เปิดใช้งาน</label>
                    </div>
                </div>
                <div className="col-12">
                    <button type="button" className="btn btn-primary">อัพเดตข้อมูล</button>
                    <button type="button" className="btn btn-light ms-2">ยกเลิก</button>
                </div>
            </form>
        </div>
    </main>
    );
} 